import { selectAuth } from "@redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { ComponentTopSpender } from "src/Components/TopSpender";

export const PageTopSpender = () => {
    const { userInfo } = useSelector(selectAuth);

    return <ComponentTopSpender userInfo={userInfo} />;
};
